import orderBy from 'lodash/orderBy';
import React from 'react';
import { connect } from 'react-redux';

import { useIntl } from 'react-intl';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Icon from '~/ui/components/Icon/Icon';
import Text from '~/ui/components/Text/Text';
import { useToggle } from '~/ui/hooks/useToggle';

function TreeItem({ isRoot = false, item, selectedItemId, setSelectedItemId }) {
  const intl = useIntl();
  const [isExpanded, toggleIsExpanded] = useToggle(isRoot);

  const isEmpty = !item.children?.length;
  const isSelected = item.id === selectedItemId;

  const sortedItemChildren = orderBy(item.children, [
    (child) => child.name.toLowerCase(),
  ]);

  return (
    <FlexLayout flexDirection="column">
      <FlexLayout alignItems="center" space={2}>
        {!isEmpty && (
          <Icon
            color="gray-700"
            icon={isExpanded ? 'chevronDown' : 'chevronRight'}
            size="s"
            title={
              isExpanded
                ? intl.formatMessage({
                    id: 'FolderTree.collapseTitle',
                    defaultMessage: 'collapse',
                    description: 'Button title to collapse folder tree',
                  })
                : intl.formatMessage({
                    id: 'FolderTree.expandTitle',
                    defaultMessage: 'expand',
                    description: 'Button title to expand folder tree',
                  })
            }
            onClick={toggleIsExpanded}
          />
        )}
        <Text
          color={isSelected ? 'gray-900' : 'gray-800'}
          ml={isEmpty ? '28px' : 0}
          variant={isSelected ? 'm-spaced-bold' : 'm-spaced'}
          onClick={() => setSelectedItemId(item.id)}
        >
          {item.name}
        </Text>
      </FlexLayout>
      {isExpanded && (
        <FlexLayout flexDirection="column" sx={{ pl: 6 }}>
          {sortedItemChildren.map((child) => (
            <TreeItem
              item={child}
              key={child.id}
              selectedItemId={selectedItemId}
              setSelectedItemId={setSelectedItemId}
            />
          ))}
        </FlexLayout>
      )}
    </FlexLayout>
  );
}

function FolderTree({
  selectedItemId,
  setSelectedItemId,
  // connected
  folderTree,
}) {
  return (
    <FlexLayout flexDirection="column">
      <TreeItem
        isRoot
        item={folderTree}
        selectedItemId={selectedItemId}
        setSelectedItemId={setSelectedItemId}
      />
    </FlexLayout>
  );
}

function mapStateToProps({ client }) {
  return { folderTree: client.folderTree };
}

export default connect(mapStateToProps)(FolderTree);
